import React from 'react';
import CrudTable from '../../components/common/CrudTable';
import { eventAPI } from '../../api/services';
import { formatCurrency } from '../../utils/formatters';

const COLUMNS = [
  { key: 'title', label: 'Title' },
  { key: 'description', label: 'Description', render: (item) => (
    <div className="tooltip-container">
      <div style={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {item.description || '—'}
      </div>
      {item.description?.length > 40 && (
        <span className="tooltip-text" style={{ bottom: '100%', left: '0', transform: 'none' }}>
          {item.description}
        </span>
      )}
    </div>
  ) },
  { key: 'location', label: 'Location' },
  { key: 'date', label: 'Date & Time', render: (item) => item.date ? item.date.replace('T', ' ').substring(0, 16) : '—' },
  { key: 'price', label: 'Price', render: (item) => item.price === 0 ? 'Free' : formatCurrency(item.price) },
  { key: 'mediaUrl', label: 'Image', render: (item) => item.mediaUrl ? <img src={item.mediaUrl} alt="" style={{ width: 48, height: 32, objectFit: 'cover', borderRadius: 6 }} /> : '—' },
];

const FORM_FIELDS = [
  { name: 'title', label: 'Title', placeholder: 'Marathon 2026' },
  { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Event details...' },
  { name: 'date', label: 'Date & Time', type: 'datetime-local' },
  { name: 'location', label: 'Location', placeholder: 'Tashkent' },
  { name: 'price', label: 'Price (UZS)', type: 'number', placeholder: '0 for free', defaultValue: 0 },
  { name: 'mediaId', label: 'Event Image', type: 'file' },
];

const EventsAdmin = () => (
  <CrudTable
    title="Events"
    entityName="Event"
    columns={COLUMNS}
    formFields={FORM_FIELDS}
    fetchData={async () => {
      const res = await eventAPI.getAll();
      return res.data?.data || [];
    }}
    onAdd={(data) => eventAPI.add(data)}
    onUpdate={(id, data) => eventAPI.update(id, data)}
    onDelete={(id) => eventAPI.delete(id)}
  />
);

export default EventsAdmin;
